export function formatPercentage(source) {
  if (!source) {
    return 'N/A';
  }
  return `${Number.parseFloat(source).toFixed(2)}%`;
}
